module.exports = __webpack_public_path__ + "img/products-account-details.212c9649.png";